import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { MenuItem, Select, Switch } from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";

import { axiosInstance } from "./../../utility/apiInstance";
import { useNavigate } from "react-router-dom";
import "./organization.css";
import InputMask from "react-input-mask";
import { useRole } from "../../components/MangeContextProvide";

import ScheduleIcon from "@mui/icons-material/Schedule";
import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridSlots,
  GridToolbarProps,
} from "@mui/x-data-grid";
import { useMediaQuery } from "@mui/material";
import toast from "react-hot-toast";
import {
  hideToggleButton,
  hideToggleButtonEditMode,
  preventAddingDuplocateRow,
} from "../../utility/constant";
import LoaderComponent from "../Loader";
import { Modal, Typography } from "@mui/material";
import { User, UserCheck, UserX } from "lucide-react";
import WhatsAppDrawer from "./WhatsAppDrawer";
import SearchInput from "../../common/SearchInput";
import TrackingThresholdDrawer from "../trackingThreshold/TrackingThresholdDrawer";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  actionText,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  actionText: string;
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding: 4,
          borderRadius: 2,
          boxShadow: 24,
          width: 400,
        }}
      >
        <Typography variant="h6">{message}</Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 2,
          }}
        >
          <Button variant="outlined" onClick={onClose}>
            No
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            {actionText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default function FullFeaturedCrudGrid() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const is1366 = useMediaQuery("(max-width:1366px)");
  const navigate = useNavigate();
  const [rows, setRows] = React.useState<GridRowsProp>([]);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  );
  const [currentPage, setCurrentPage] = React.useState(0);
  const [countries, setCountries] = React.useState<any[]>([]);
  const [cities, setCities] = React.useState<any[]>([]);
  const [selectedCountry, setSelectedCountry] = React.useState<any>(null);
  const [selectedCity, setSelectedCity] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalMessage, setModalMessage] = React.useState("");
  const [modalActionText, setModalActionText] = React.useState("");
  const [selectedRow, setSelectedRow] = React.useState<{
    id: GridRowId;
    row: any;
  } | null>(null);
  const { role, organizationId } = useRole() as any;
  const [totalOrganization, setTotalOrganization] = React.useState(0);
  const [activeOrganization, setActiveOrganization] = React.useState(0);
  const [inActiveOrganization, setInActiveOrganization] = React.useState(0);
  const [isAddDisabled, setIsAddDisabled] = React.useState(false);
  const [whatsAppDrawer, setWhatsAppDrawer] = React.useState(false);
  const [userId, setUserId] = React.useState("")

  const [searchQuery, setSearchQuery] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState("");

  const [thresholdDrawer, setThresholdDrawer] = React.useState(false);
  const [thresholdOrgId, setThresholdOrgId] = React.useState("");

  // debounce search effect
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);


  // Fix the debounced effect — pass the string directly
  React.useEffect(() => {
    fetchOganizationList(debouncedSearch);
  }, [debouncedSearch]);


  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleThresholdDrawer = (id: any) => {
    setThresholdOrgId(id);
    setThresholdDrawer(true);
  };

  const fetchOganizationList = async (search: string = "") => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/api/v1/organisation?search=${search}`);
      const fetchedRows = response?.data?.data;
      const data = fetchedRows.map((row: any, index: any) => ({
        ...row,
        key: row?._id || row?.id,
        id: row?._id || row?.id,
        module: row?.module,
        ishideToggle: true,
        isNew: false,
        Organization_Name: row?.organizationName,
        PAN: row?.pan,
        GST: row?.gst,
        Office_Country: row?.officeCountry,
        Office_City: row?.officeCity,
        Address: row?.address,
        Mobile_Number: row?.mobileNumber,
        Admin_Email: row?.adminEmailId,
        numberOfLicenses: row?.numberOfLicenses,
        licensesconsumed: row?.consumeLiecence,
        s_no: index + 1,
      }));
      setRows(data);
      setLoading(false);
      if (response.data.statusCode === 401) {
        handleLogout();
      }
    } catch (err: any) {
      setLoading(false);
    }
  };

  const countriesdata = async () => {
    try {
      const response = await axiosInstance.get("api/v1/country");
      const fdata = response.data.data.filter(
        (item: any, index: number, arr: any) =>
          arr.findIndex((obj: any) => obj.name === item.name) === index
      );
      setCountries(fdata);
    } catch (err: any) { }
  };

  const fetchCities = async (countryId: string) => {
    try {
      const response = await axiosInstance.get(`/api/v1/city/${countryId}`);
      const fdata = response.data.data.filter(
        (item: any, index: number, arr: any) =>
          arr.findIndex((obj: any) => obj.cityName === item.cityName) === index
      );
      setCities(response.data.data);
    } catch (err: any) {
      toast.error("Failed to fetch cities");
    }
  };

  React.useEffect(() => {
    fetchOganizationList(debouncedSearch);
    countriesdata();
  }, []);


  interface EditToolbarProps extends GridToolbarProps {
    setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
    setRowModesModel: (
      newModel: (oldModel: GridRowModesModel) => GridRowModesModel
    ) => void;
    currentPage: number;
    isAddDisabled: boolean;
    setIsAddDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  }

  React.useEffect(() => {
    if (selectedCountry) {
      fetchCities(selectedCountry._id);
    } else {
      setCities([]);
    }
  }, [selectedCountry]);

  const handleRowEditStop: GridEventListener<"rowEditStop"> = (
    params,
    event
  ) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId, row: any) => () => {
    const data = countries?.find(
      (country) => country?.name === row?.officeCountry
    );
    data && fetchCities(data?._id);

    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    setIsAddDisabled(true);
  };





  const handleConfirmAction = async () => {
    if (!selectedRow) return;
    const { id, row } = selectedRow;
    const updatedStatus = { isActive: !row.isActive };

    try {
      const response = await axiosInstance.post(
        `/api/v1/organisation/soft-delete/${id}`,
        updatedStatus
      );
      if (response.status === 200) {
        fetchOrganizationCount();
        toast.success(response?.data?.message);
        fetchOganizationList();
        setRows((prev) => {
          let array = [...prev];
          let findIndex = array.findIndex(
            (item: any) => item?._id === response?.data?.data?._id
          );
          if (findIndex !== -1) {
            array[findIndex] = response?.data?.data;
          }
          return array;
        });
      } else {
        toast.error("Error updating user status.");
      }
    } catch (error: any) {
      toast.error("An error occurred while updating user status.");
    }
    setModalOpen(false);
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow: any = rows.find((row: any) => row.id === id);
    if (editedRow?.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
      setIsAddDisabled(false);
    }

    if (!editedRow.isNew) {
      setRows((prev: any) => {
        let array = [...prev];
        let findIndex = array.findIndex((item: any) => item?._id === id);
        if (findIndex !== -1) {
          array[findIndex].ishideToggle = true;
        }
        return array;
      });
    }
    setIsAddDisabled(false);
  };


  const processRowUpdate = async (newRow: GridRowModel, params: any) => {
    const updatedRow: any = { ...newRow, isNew: false };
    const errors: any[] = [];


    if (errors.length > 0) {
      if (
        updatedRow.id ===
        rows?.find((item: any) => item._id === updatedRow._id)?._id
      ) {
        setRows(hideToggleButton(rows, updatedRow.id));
      }

      errors.forEach((error) => toast.error(error));
      return;
    }
    if (+updatedRow.id < 1) {
      const formData = {
        organizationName: updatedRow.Organization_Name,
        pan: updatedRow.PAN,
        gst: updatedRow.GST,
        officeCountry: updatedRow.Office_Country,
        officeCity: updatedRow.Office_City,
        address: updatedRow.Address,
        mobileNumber: updatedRow.Mobile_Number,
        adminEmailId: updatedRow.Admin_Email,
        // numberOfLicenses: Number(updatedRow.numberOfLicenses),
        module: menuOptionsformdata[updatedRow.module] || updatedRow.module,
      };
      try {
        const response = await axiosInstance.post(
          "api/v1/organisation/create",
          formData
        );
        toast.success("Organisation created successfully.");

        setRows((prevRows) => {
          const filteredRows = prevRows.filter(row => row.id !== updatedRow.id);
          return [
            {
              ...response?.data?.data,
              id: response?.data?.data?._id,
              key: response?.data?.data?._id,
              Organization_Name: response?.data?.data?.organizationName,
              PAN: response?.data?.data?.pan,
              GST: response?.data?.data?.gst,
              Office_Country: response?.data?.data?.officeCountry,
              Office_City: response?.data?.data?.officeCity,
              Address: response?.data?.data?.address,
              Mobile_Number: response?.data?.data?.mobileNumber,
              Admin_Email: response?.data?.data?.adminEmailId,
              // numberOfLicenses: response?.data?.data?.numberOfLicenses,
              module: response?.data?.data?.module,
              isActive: true,
              isNew: false,
              ishideToggle: true,
            },
            ...filteredRows,
          ];
        });

        setIsAddDisabled(false);
        return {
          ...response?.data?.data,
          id: response?.data?.data?._id,
          isNew: false,
        };
      } catch (err: any) {
        if (
          updatedRow.id ===
          rows?.find((item: any) => item._id === updatedRow._id)?._id
        ) {
          setRows(hideToggleButton(rows, updatedRow.id));
        }

        Array.isArray(err.response.data.error)
          ? err?.response.data.error.forEach((error: any) => {
            toast.error(`${error.message}`);
          })
          : toast.error(err.response.data.error);
      }
    } else {
      const sendData = {
        organizationName: updatedRow.Organization_Name,
        pan: updatedRow.PAN,
        gst: updatedRow.GST,
        officeCountry: updatedRow.Office_Country,
        officeCity: updatedRow.Office_City,
        address: updatedRow.Address,
        mobileNumber: updatedRow.Mobile_Number,
        adminEmailId: updatedRow.Admin_Email,
        isWebhookAllowed: updatedRow.isWebhookAllowed,
        module: menuOptionsformdata[updatedRow.module] || updatedRow.module,
      };
      const country = countries.find(
        (item: any) => item.name === updatedRow.Office_Country
      );
      try {
        const response = await axiosInstance.patch(
          `/api/v1/organisation/update/${newRow.id}`,
          sendData
        );
        if (response.status === 200) {
          toast.success(response.data.message);
          fetchOganizationList();
          setRows((prev) => {
            let array = [...prev];
            let findIndex = array.findIndex(
              (item: any) => item?._id === response?.data?.data?._id
            );
            if (findIndex !== -1) {
              array[findIndex] = response?.data?.data;
            }
            return array;
          });
          return updatedRow;
        }
      } catch (err: any) {
        if (
          updatedRow.id ===
          rows?.find((item: any) => item._id === updatedRow._id)?._id
        ) {
          setRows(
            (prevRows: any) => hideToggleButtonEditMode(prevRows, updatedRow)
          );
        }

        if (Array.isArray(err.response?.data?.error)) {
          err.response.data.error.forEach((error: any) => {
            toast.error(`${error.message}`);
          });
        } else {
          toast.error(
            err.response?.data?.error ||
            "An error occurred while updating the organization."
          );
        }
        setRows((prevRows: any) =>
          hideToggleButtonEditMode(prevRows, updatedRow)
        );
      }
    }
  };

  const fetchOrganizationCount = async () => {
    try {
      let response = await axiosInstance.get(
        `/api/v1/organisation/organization-count`
      );
      if (response?.data?.success) {
        const { totalOganizations, activeOganizations, inActiveOganizations } =
          response.data.data;

        setTotalOrganization(totalOganizations);
        setActiveOrganization(activeOganizations);
        setInActiveOrganization(inActiveOganizations);
      }
    } catch (error: any) { }
  };

  React.useEffect(() => {
    fetchOrganizationCount();
  }, []);

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationChange = (paginationModel: any) => {
    setCurrentPage(paginationModel.page);
  };


  const handleWhatsAppDrawer = (id: any) => {
    setWhatsAppDrawer(true);
    setUserId(id);
  }



  const menuOptions: Record<string, string> = {
    "1": "Air",
    "2": "Ocean",
    "3": "IDP",
  };
  const menuOptionsformdata = {
    Air: "1",
    Ocean: "2",
    IDP: "3"
  } as any;

  const columns: GridColDef[] = [
    {
      field: "s_no",
      headerName: "S.No.",
      // width: isMobile ? 120 : 60,
      width: is1366 ? 60 : 70,
      sortable: true,
      filterable: false,
      editable: false,
      disableColumnMenu: true,
    },
    {
      field: "Organization_Name",
      headerName: "Organization Name",
      //width: 150,
      width: is1366 ? 150 : 190,
      sortable: true,
      filterable: true,
      editable: false,
    },
    {
      field: "PAN",
      headerName: "PAN",
      //width: 130,
      width: is1366 ? 120 : 120,
      sortable: true,
      filterable: true,
      editable: false,
    },
    {
      field: "GST",
      headerName: "GST",
      // width: 150,
      width: is1366 ? 130 : 130,
      sortable: true,
      filterable: true,
      editable: false,
    },
    {
      field: "Office_Country",
      headerName: "Country",
      // width: 130,
      width: is1366 ? 80 : 120,
      sortable: true,
      filterable: true,
      editable: false,
      renderEditCell: (params) => (
        <Autocomplete
          value={
            countries.find((country) => country.name === params.value) || null
          }
          onChange={(event, newValue) => {
            setSelectedCountry(newValue);
            setSelectedCity(null);

            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newValue ? newValue.name : "",
            });
            if (newValue) {
              fetchCities(newValue._id);
            }
            params.api.setEditCellValue({
              id: params.id,
              field: "Office_City",
              value: "",
            });
          }}
          options={countries}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "12px",
                },
              }}
            />
          )}
          sx={{
            width: "100%",
            "& .MuiAutocomplete-popupIndicator": { display: "none" },
            "& .MuiAutocomplete-popper": {
              minWidth: "300px",
              maxWidth: "500px",
            },
          }}
          componentsProps={{
            popper: {
              sx: {
                "& .MuiAutocomplete-listbox": {
                  fontSize: "12px",
                },
                "& .MuiAutocomplete-option": {
                  fontSize: "12px",
                },
              },
            },
          }}
        />
      ),
    },
    {
      field: "Office_City",
      headerName: "State",
      // width: 130,
      width: is1366 ? 80 : 120,
      sortable: true,
      filterable: true,
      editable: false,
      renderEditCell: (params) => (
        <Autocomplete
          value={cities.find((city) => city.cityName === params.value) || null}
          onChange={(event, newValue) => {
            setSelectedCity(newValue);
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newValue ? newValue.cityName : "",
            });
          }}
          options={cities}
          getOptionLabel={(option) => option.cityName}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              fullWidth
              sx={{
                "& .MuiInputBase-input": {
                  fontSize: "12px",
                },
              }}
            />
          )}
          sx={{
            width: "100%",
            "& .MuiAutocomplete-popupIndicator": { display: "none" },
            "& .MuiAutocomplete-popper": {
              minWidth: "300px",
              maxWidth: "500px",
            },
          }}
          componentsProps={{
            popper: {
              sx: {
                "& .MuiAutocomplete-listbox": {
                  fontSize: "12px",
                },
                "& .MuiAutocomplete-option": {
                  fontSize: "12px",
                },
              },
            },
          }}
        />
      ),
    },
    {
      field: "Address",
      headerName: "Address",
      // width: 150,
      width: is1366 ? 180 : 200,
      sortable: true,
      filterable: true,
      editable: false,
    },
    {
      field: "Mobile_Number",
      headerName: "Mobile No.",
      // width: 120,
      width: is1366 ? 120 : 120,
      sortable: true,
      filterable: true,
      editable: false,
      renderEditCell: (params) => {
        const handlePhoneNumberChange = (
          event: React.ChangeEvent<HTMLInputElement>
        ) => {
          params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: event.target.value,
          });
        };

        return (
          <InputMask
            mask="9999999999"
            maskChar={null}
            value={params.value || ""}
            onChange={handlePhoneNumberChange}
          >
            {(inputProps: any) => (
              <TextField
                {...inputProps}
                fullWidth
                inputProps={{
                  maxLength: 13,
                }}
              />
            )}
          </InputMask>
        );
      },
    },
    {
      field: "Admin_Email",
      headerName: "Contact Email ID",
      // width: 180,
      width: is1366 ? 180 : 200,
      sortable: true,
      filterable: true,
      editable: false,
    },


    {
      field: "module",
      headerName: "Module",
      //width: isMobile ? 120 : 120,
      width: is1366 ? 120 : 130,
      sortable: true,
      filterable: true,
      editable: false,
      renderCell: (params) => {
        return (
          <div>
            {Array.isArray(params.value)
              ? params.value.map((val) => menuOptions[val]).join(", ")
              : ""}
          </div>
        );
      },
      renderEditCell: (params) => {
        const handleChange = (event: any) => {
          const {
            target: { value },
          } = event;
          params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: Array.isArray(value) ? value : [value],
          });
        };

        return (
          <Select
            multiple
            value={Array.isArray(params.value) ? params.value : []}
            onChange={handleChange}
            renderValue={(selected) =>
              Array.isArray(selected)
                ? selected.map((val) => menuOptions[val]).join(", ")
                : ""
            }
            sx={{
              width: "100%",
              backgroundColor: "#f0f0f0",
              height: "35px",
              marginTop: "7px",
              borderRadius: "4px",
            }}
          >

            {Object.entries(menuOptions).map(([key, value]) => (
              <MenuItem value={key}>
                {value}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },


    {
      field: "isActive",
      headerName: "Status",
      // width: isMobile ? 150 : 70,
      width: is1366 ? 70 : 80,
      sortable: true,
      filterable: false,
      renderCell: (params) => (params.row.isActive ? "Active" : "Inactive"),
    },
    {
      field: "isWebhookAllowed",
      headerName: "Contact Webhook",
      // width: isMobile ? 180 : 160,
      width: is1366 ? 140 : 140,
      flex: 0,
      sortable: true,
      filterable: true,
      editable: true,
      renderCell: (params) => (
        <span
          style={{
            fontSize: "12px",
            fontWeight: 700,
            color: params.value ? "#0B5ED7" : "#6C757D",
            textDecoration: params.value ? "none" : "line-through",
          }}
        >
          {params.value ? "Enabled" : "Disabled"}
        </span>

      ),
      renderEditCell: (params) => {
        const handleToggle = (
          event: React.ChangeEvent<HTMLInputElement>
        ) => {
          params.api.setEditCellValue({
            id: params.id,
            field: params.field,
            value: event.target.checked,
          });
        };

        return (
          <Switch
            className="thinSwitch"
            checked={Boolean(params.value)}
            onChange={handleToggle}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#2e7d32",
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#2e7d32",
              },
              "& .MuiSwitch-switchBase": {
                color: "#c62828",
              },
              "& .MuiSwitch-track": {
                backgroundColor: "#c62828",
              },
            }}
          />
        );
      },
    }

    ,
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
     
      width: is1366 ? 150 : 150,
      cellClassName: "actions",
      getActions: ({ id, row }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <>
              <GridActionsCellItem
                key={`edit-${id}`}
                icon={<EditIcon />}
                label="Edit"
                className="iconMilestone_edit"
                onClick={handleEditClick(id, row)}
                color="inherit"
              />
              <GridActionsCellItem
                key={`whatsapp-${id}`}
                icon={<WhatsAppIcon />}
                label="WhatsApp"
                className="iconMilestone_whatsapp"
                onClick={() => handleWhatsAppDrawer(id)}
                color="inherit"
              />
              <GridActionsCellItem
                key={`threshold-${id}`}
                icon={
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      backgroundColor: "#f5a524",
                      color: "#fff",
                    }}
                  >
                    <ScheduleIcon sx={{ fontSize: 18 }} />
                  </span>
                }
                label="Tracking Threshold"
                onClick={() => handleThresholdDrawer(id)}
                color="inherit"
              />
            </>,
          ];
        }

        if (!row?.ishideToggle) {
          return [<></>];
        }
        return [
          <>
            <GridActionsCellItem
              key={`edit-${id}`}
              icon={<EditIcon />}
              label="Edit"
              className="iconMilestone_edit"
              onClick={handleEditClick(id, row)}
              color="inherit"
            />
            <GridActionsCellItem
              key={`whatsapp-${id}`}
              icon={<WhatsAppIcon />}
              label="WhatsApp"
              className="iconMilestone_whatsapp"
              onClick={() => handleWhatsAppDrawer(id)}
              color="inherit"
            />
            <GridActionsCellItem
              key={`threshold-${id}`}
              icon={
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    backgroundColor: "#f5a524",
                    color: "#fff",
                  }}
                >
                  <ScheduleIcon sx={{ fontSize: 18 }} />
                </span>
              }
              label="Tracking Threshold"
              onClick={() => handleThresholdDrawer(id)}
              color="inherit"
            />
          </>,
        ];
      },
    },
  ];

  return (
    <>
      {role === "admin" && (
        <div className="grid grid-cols-12 mt-5 gap-5 mb-1">
          <div className="col-span-12 lg:col-span-4 sm:col-span-4 md:col-span-4">
            <div className="BoxWhite flex justify-between iconsize">
              <>
                <aside>
                  <span className="text-base">Total Organization</span>
                  <h6 className="text-lg font-bold text-orange-400">{totalOrganization}</h6>
                </aside>

                <figure className="shape justify-center flex">
                  <User className="w-8 h-8 text-orange-400" />
                </figure>
              </>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 sm:col-span-4 md:col-span-4">
            <div className="BoxWhite flex justify-between iconsize">
              <aside>
                <span className="text-base">Active Organization</span>
                <h6 className="text-lg font-bold text-green-500">{activeOrganization}</h6>
              </aside>

              <figure className="shape justify-center flex">
                <UserCheck className="w-8 h-8 text-green-500" />
              </figure>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 sm:col-span-4 md:col-span-4">
            <div className="BoxWhite flex justify-between iconsize">
              <aside>
                <span className="text-base">Inactive Organization</span>
                <h6 className="text-lg font-bold text-red-500">
                  {inActiveOrganization}
                </h6>
              </aside>

              <figure className="shape justify-center flex">
                <UserX className="w-8 h-8 text-red-500" />
              </figure>
            </div>
          </div>
        </div>
      )}
      <div className="old_dashboard_title flex items-center justify-between mb-[10px]">
        <h1 className="text-2xl font-bold text-gray-700 m-0">
          Organizations
        </h1>
        <SearchInput
          placeholder="Search"
          onChange={setSearchQuery}
          width={400}
        />

      </div>


      {whatsAppDrawer &&
        <WhatsAppDrawer
          whatsAppDrawer={whatsAppDrawer}
          onClose={() => { setWhatsAppDrawer(false); setUserId("") }}
          organizationId={userId} />
      }

      {thresholdDrawer && (
        <TrackingThresholdDrawer
          open={thresholdDrawer}
          organizationId={thresholdOrgId}
          onClose={() => {
            setThresholdDrawer(false);
            setThresholdOrgId("");
          }}
        />
      )}
      <div className="whiteBox">
        <Box
          sx={{
            // height: 520,
            width: "100%",
            "& .actions": {
              color: "text.secondary",
            },
            "& .textPrimary": {
              color: "text.primary",
            },
            // boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
          }}
        >
          {loading ? (
            <LoaderComponent height={"85vh"} />
          ) : (
            <DataGrid
              rows={rows?.map((item: any, index: number) => ({
                ...item,
                s_no: index + 1,
              }))}
              columns={columns}
              getRowHeight={() => "auto"}
              getEstimatedRowHeight={() => 52}
              editMode="row"
              rowModesModel={rowModesModel}
              onRowModesModelChange={handleRowModesModelChange}
              onRowEditStop={handleRowEditStop}
              processRowUpdate={processRowUpdate}
              onPaginationModelChange={handlePaginationChange}
              isCellEditable={(params) => {
                const isInEditMode =
                  rowModesModel[params.id]?.mode === GridRowModes.Edit;
                return isInEditMode;
              }}
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } },
              }}
              pageSizeOptions={[10]}
              getRowId={(row) => row?.id || row?._id}
              // slots={{
              //   toolbar: EditToolbar as GridSlots["toolbar"],
              // }}
              slotProps={{
                toolbar: {
                  setRows,
                  setRowModesModel,
                  currentPage,
                  isAddDisabled,
                  setIsAddDisabled,
                } as EditToolbarProps,
              }}
              sx={{
                '& .MuiDataGrid-cell': {
                  display: "flex",
                  alignItems: "center",
                },
                '& .MuiDataGrid-cellContent': {
                  whiteSpace: 'normal !important',
                  overflowWrap: 'break-word',
                },
              }}
              autoHeight
              rowHeight={38}
              columnHeaderHeight={42}
            />
          )}
          <ConfirmationModal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
            onConfirm={handleConfirmAction}
            message={modalMessage}
            actionText={modalActionText}
          />
        </Box>
      </div>
    </>
  );
}
